import { BLUE_GREY_100, BLUE_GREY_200, LILAC_400, WHITE } from '@airtel/air-design-system';
export var updateIsSelectedKey = (arr, arrIndex) => {
  return arr === null || arr === void 0 ? void 0 : arr.map((item, index) => {
    item.isSelected = arrIndex === index;
    return item;
  });
};
export var convertIntoDate = date => {
  var longDate = date && Number(date) || 0;
  return new Date(longDate);
};
export var checkIfDateAreSame = (selectedDate, date) => {
  var _selectedDate = convertIntoDate(selectedDate);
  var _date = convertIntoDate(date);
  return _selectedDate.getDate() === _date.getDate();
};
export var clearCarousel = carousel => {
  return carousel === null || carousel === void 0 ? void 0 : carousel.map(carouselItem => {
    var _a;
    carouselItem.isSelected = false;
    (_a = carouselItem === null || carouselItem === void 0 ? void 0 : carouselItem.slotList) === null || _a === void 0 ? void 0 : _a.map(slotItem => {
      slotItem.isSelected = false;
      slotItem.isDisabled = true;
    });
    return carouselItem;
  });
};
export var getDayFromDate = date => {
  var _date = convertIntoDate(date);
  return _date.getDate();
};
export var checkMinAndMaxDate = (selectDate, minDate, maxDate) => {
  var _selectedDate = new Date(Number(selectDate));
  var _minDate = new Date(Number(minDate));
  var _maxDate = new Date(Number(maxDate));
  return _selectedDate >= _minDate && _selectedDate <= _maxDate;
};
export var getThemeStyles = function getThemeStyles(theme) {
  if (theme === void 0) {
    theme = 'light';
  }
  var white = {
    borderColor: BLUE_GREY_200,
    backgroundColor: BLUE_GREY_100
  };
  var light = {
    borderColor: WHITE,
    backgroundColor: LILAC_400
  };
  switch (theme) {
    case 'white':
      return white;
    case 'light':
      return light;
    default:
      return light;
  }
};